export default [
  {
    _name: 'CSidebarNav',
    _children: [
      {
        _name: 'CSidebarNavTitle',
        _children: ['会員情報'],
        _class: 'parent_tab'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'ダッシュボード',
        to: '/dashboard',
        icon: 'cil-speedometer',
      },
      {
        _name: 'CSidebarNavItem',
        name: '会員情報',
        to: '/profile',
        icon: 'cil-pencil',
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Eメール設定',
        to: '/email-settings',
        icon: 'cil-pencil',
      },
      {
        _name: 'CSidebarNavTitle',
        _children: ['会員管理'],
        _class: 'parent_tab'
      },
      {
        _name: 'CSidebarNavItem',
        name: '会員シート打込み',
        to: '/members-card-add',
        icon: 'cil-plus',
      },
      {
        _name: 'CSidebarNavItem',
        name: '新規会員ID',
        to: '/new-member-id',
        icon: 'cil-plus',
      },
      {
        _name: 'CSidebarNavItem',
        name: '会員検索',
        to: '/member-search',
        icon: 'cil-list',
      },
      {
        _name: 'CSidebarNavTitle',
        _children: ['クーポン管理'],
        _class: 'parent_tab'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'クーポン登録',
        to: '/coupon-create',
        icon: 'cil-plus',
      },
      {
        _name: 'CSidebarNavItem',
        name: 'クーポン一覧',
        to: '/coupon-list/list',
        icon: 'cil-list',
      },
      {
        _name: 'CSidebarNavItem',
        name: '割引プラン一覧',
        to: '/discount-plan-list',
        icon: 'cil-pencil',
      },
      {
        _name: 'CSidebarNavItem',
        name: 'クーポン操作',
        to: 'coupon-operation',
        icon: 'cil-gift',
      },
      {
        _name: 'CSidebarNavTitle',
        _children: ['ログアウト'],
        _class: 'parent_tab'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'ログアウト',
        to: '/logout',
        icon: 'cil-room'
      }
    ]
  }
]